import React from 'react';
import { GuestButtons } from '@components';
import usePageTitle from '@hooks/usePageTitle';

const CaptivePortalGuestProcessing = () => {
  usePageTitle('Account Processing');
  return (
    <div className="flex justify-center py-3">
      <div className="w-full space-y-2 md:w-4/5 md:max-w-lg">
        <div className="mb-2 text-center">
          <h2 style={{ fontSize: '125%' }} className="pb-5">
            Almost there - your account is being created!
          </h2>
        </div>
        While we finish setting things up, click Continue to get immediate guest access to the
        internet. We’ll email you as soon as your account is ready with instructions to get started.
        <GuestButtons captivePortal />
      </div>
    </div>
  );
};

export default CaptivePortalGuestProcessing;
